import React from 'react';

// Styles & Assets
import styles from './Searchbar.module.css';
import { AiOutlineSearch } from 'react-icons/ai';

// Components
import Icon from '../Icon/Icon';

const Searchbar: React.FC<{
    handleChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
    defaultValue?: string
    placeholder?: string
}> = ({ handleChange, defaultValue, placeholder = '' }) => {

    return (
        <div className={styles.searchBarContainer}>
            <div className={styles.searchBar}>
                <input 
                    defaultValue={defaultValue} 
                    onChange={handleChange} 
                    type='text' 
                    className={styles.inputSearchBar} 
                    placeholder={placeholder}
                />
                <Icon><AiOutlineSearch /></Icon>
            </div>
        </div>
    );
};

export default Searchbar;